import React from 'react';

import CrossIcon from './cross.svg';

export default props => <img {...props} src={CrossIcon} alt="" />;
